import {
  Modal,
  SpaceBetween,
  ColumnLayout,
  Container,
  Button
} from "@amzn/awsui-components-react";
import {TestCase} from "../../types/UATProject";
import {SummaryItem} from "../summary/SummaryItem";

interface TestCaseSummaryModalProps {
  visible: boolean;
  onDismiss: () => void;
  testCase: TestCase | null;
}

export function TestCaseSummaryModal({
                                       visible,
                                       onDismiss,
                                       testCase
                                     }: TestCaseSummaryModalProps) {

  if (!testCase) {
    return null;
  }

  const formatValue = (value: any): string => {
    if (value === null || value === undefined) {
      return "-";
    }
    if (typeof value === 'object') {
      return JSON.stringify(value);
    }
    return String(value);
  };

  return (
      <Modal
          visible={visible}
          onDismiss={onDismiss}
          header="Test Case Details"
          size="large"
          footer={
            <Button variant="primary" onClick={onDismiss}>
              Close
            </Button>
          }
      >
        <SpaceBetween size="l">
          <Container header={<h2>Basic Information</h2>}>
            <SpaceBetween size="m">
              <ColumnLayout columns={2} variant="text-grid">
                <SummaryItem
                    label="Test Case ID"
                    value={formatValue(testCase.name)}
                />
              </ColumnLayout>
            </SpaceBetween>
          </Container>
        </SpaceBetween>
      </Modal>
  );
}
